import { render } from "./JobenterpriseAllocation.vue?vue&type=template&id=2e17f6ff&scoped=true"
import script from "./JobenterpriseAllocation.vue?vue&type=script&lang=js"
export * from "./JobenterpriseAllocation.vue?vue&type=script&lang=js"

import "./JobenterpriseAllocation.vue?vue&type=style&index=0&id=2e17f6ff&scoped=true&lang=css"
import "./JobenterpriseAllocation.vue?vue&type=style&index=1&id=2e17f6ff&lang=css"
script.render = render
script.__scopeId = "data-v-2e17f6ff"

export default script